import styled from 'styled-components';
// import { color } from 'styles/pallete';

export const errorForm = styled.div`
	width: 50vw;
	height: 50vh;
	display: flex;
	align-items: center;
	justify-content: center;
	> p {
		font-size: 1.5rem;
		font-weight: bolder;
	}
`;
